
export const ClaimType = {
  REIMBURSEMENT : "reimbursement",
  CASHLESS : "cashless",
}
